import axios from '../axios';
import * as object from '../object';
import { G } from '../querystring';

declare interface myWindow extends Window {
    pageRequestID: string;
    GetPageRequestID(): Promise<string>;
    pageRequestIDPromise: Promise<string> | undefined;
}
declare const window: myWindow;

declare interface createPageRequestResp {
    pageRequestID?: string;
}

async function createPageRequest() {
    let referrer = document.referrer || G().Get('ref') || '';
    if (/^https?:\/\/$/i.test(referrer)) {
        referrer = '';
    }

    const xhr = axios.post<createPageRequestResp>('/page-requests', {
        'url': window.location.href,
        'referrer': referrer,
    });

    return xhr.then(resp => {
        if (!resp.data.pageRequestID || typeof resp.data.pageRequestID !== 'string') {
            return;
        }

        window.pageRequestID = resp.data.pageRequestID;

        window.onbeforeunload = () => {
            if (resp.data.pageRequestID) {
                UpdatePageRequest(resp.data.pageRequestID).catch(() => ({
                    // don't log the error here
                    // its very annoying
                }));

                // don't prompt about leaving the page
                return undefined;
            }
        };
        setInterval(() => {
            if (resp.data.pageRequestID) {
                void UpdatePageRequest(resp.data.pageRequestID);
            }
        }, 10 * 1000);

        return resp.data.pageRequestID;
    });
}

export async function UpdatePageRequest(pageRequestID: string) {
    return axios.patch(`/page-requests/${pageRequestID}`);
}

export function GetPageRequestID(): Promise<string> {
    const parent = window.parent as unknown as Record<PropertyKey, unknown>;
    if (object.HasKey(parent, 'GetPageRequestID') && GetPageRequestID !== parent['GetPageRequestID']) {
        return (parent['GetPageRequestID'] as () => Promise<string>)();
    }

    if (!window.pageRequestIDPromise) {
        window.pageRequestIDPromise = createPageRequest().then(pageRequestID => pageRequestID ?? '');
    }

    return window.pageRequestIDPromise;
}

if (typeof window !== 'undefined') {
    window.GetPageRequestID = GetPageRequestID;
}